<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        fab
        title="Add New Fund Bucket Type"
        v-on="on"
      >
        <v-icon medium>
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Fund Bucket Type
            </h4>
            <p class="category font-weight-thin">
              Create Fund Bucket Item
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-form
        v-if="dialog"
      >
        <v-container>
          <v-text-field
            v-model="name"
            v-validate="'required'"
            :error-messages="errors.collect('name')"
            data-vv-name="name"  
            label="Name"
          />
          <v-text-field
            v-model="identifier"
            v-validate="'required'"
            :error-messages="errors.collect('identifier')"
            data-vv-name="identifier"  
            label="Identifier"
          />
          <v-select
            v-model="transactionMode"
            v-validate="'required'"
            class="font-small"
            item-text="value"
            item-value="shortcode"
            :items="transactionModes"
            :error-messages="errors.collect('transactionMode')"
            data-vv-as="transaction mode"
            data-vv-name="transactionMode"
            label="Transaction Mode"
          />
          <v-card-actions>
            <v-spacer />
            <v-btn
              :loading="progressing"
              color="success"
              @click="submitForm"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        dialog: false,
        identifier: '',
        name: '',
        progressing: false,
        transactionMode: '',
        transactionModes: [],
      }
    },
    watch: {
      dialog (value) {
        if (value) {
          this.loadData()
        } else {
          this.$resetData()
        }
      },
    },
    methods: {
      loadData () {
        this.$api.lookups().list('transaction_mode')
          .then(response => {
            this.transactionModes = response.data
            this.loading = false
          })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.fundBucketTypes().create(this.prepareFormData())
              .then((response) => {
                if (response.status === 201) {
                  this.$emit('created')                
                  this.$snack({ color: 'success', message: response.data.message })

                  this.dialog = false                
                }
              }).catch(err => {
                this.$snack({ color: 'error', message: err.response.statusText })
              }).then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          name: this.name,
          identifier: this.identifier,
          transaction_mode: this.transactionMode,
        }
      },
    },
  }
</script>

<style>
  .font-small .v-label {
      font-size: 14px;
      font-weight: normal;
  }
</style>
